import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./utils/AuthContext";
import { JSX } from "react";
import { redirectState } from "./utils/routeNavigation";

export default function PrivateRoute({ children }: { children: JSX.Element }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div role="status">Checking sign-in...</div>;
  return user && !user.isAnonymous && user.email !== import.meta.env.VITE_FIREBASE_CUSTOM_IDENTIFIER
    ? children
    : <Navigate to="/login" replace state={redirectState("protected_login", { from: { pathname: location.pathname, search: location.search, hash: location.hash } })} />;
}